export const ADMIN_LOGIN_FALLBACK =
  'Đăng nhập thất bại. Kiểm tra email/mật khẩu rồi thử lại.';

/** Đổi thông điệp lỗi của server khi đăng nhập admin sang tiếng Việt. */
export const mapAdminLoginError = (serverMessage?: unknown): string => {
  if (typeof serverMessage !== 'string' || !serverMessage.trim()) {
    return ADMIN_LOGIN_FALLBACK;
  }
  const msg = serverMessage.trim();
  if (msg.toLowerCase() === 'email or password incorrect') {
    return 'Email hoặc mật khẩu không đúng.';
  }
  if (msg.toLowerCase().includes('locked out')) {
    return 'Bạn nhập sai nhiều lần nên tài khoản tạm khoá vài phút. Đợi một lát rồi thử lại, hoặc đặt lại mật khẩu ở trang đăng nhập Cab.';
  }
  return msg;
};

const AUTH_ENDPOINTS = [
  '/accounts/cms/login',
  '/accounts/cms/verify-2fa',
  '/accounts/login',
  '/accounts/external-login',
  '/tokens/refresh',
];

/** Các endpoint xác thực không bao giờ được thử refresh token khi bị 401. */
export const isAuthEndpoint = (url?: string): boolean =>
  !!url && AUTH_ENDPOINTS.some((p) => url.includes(p));
